import React from 'react';
import ReactDOM from 'react-dom';
import * as Keycloak from 'keycloak-js'
import axios from 'axios';
import * as serviceWorker from './serviceWorker';
import App from './App';
import Home from './layouts/home';
import {atualizaUserRole, getBySub, getRoles, getSelectedRole} from './services/usuario/UsuarioService';
import {BaSeRoot, BaSeDialogContainer} from '@base/react'


const getUrlApi = async (variavel) => {
  const resp = await axios.get('/env.json');
  return resp.data[variavel];
};

const getUserRoles = async (subject) => {
  try {
    const rolesResponse = getRoles(subject);
    if (rolesResponse.data) {
      return rolesResponse.data;
    }
  } catch (error) {
    console.log(error);
  }
}

const getUserSelectedRole = async (subject) => {
  try {
    const roleResponse = getSelectedRole(subject);
    if (roleResponse.data) {
      return roleResponse.data;
    }
  } catch (error) {
    console.log(error);
  }
}

const configAcessoERoles = (subject) => {

  if (roles && roles.length > 0) {
    possuiAcesso = true;
  }

  if (roles.length === 1) {
    if(role !== roles[0]){
      atualizaUserRole(subject, {roleSelecionada: roles[0]}).data;//TODO ver com o Yago como fazer para retirar esse .data
    }
    role = roles[0];
  }

  if (possuiAcesso && (role == null || roles.indexOf(role) < 0)) {
    selecionarPerfil = true;
    role = null;
  }
}

const keycloak = Keycloak('/keycloak.json');
const { pathname, protocol, host } = window.location;

let roles = [];
let role = null;
let roleSelecionada = [];
let possuiAcesso = false;
let selecionarPerfil = false;

if (pathname === '/') {
  ReactDOM.render(
    <Home />, document.getElementById('root'),
  );
} else {
  keycloak.init({ onLoad: 'login-required', flow: 'implicit' }).success(async (auth) => {
    if (!auth) {
      window.location.reload();
    } else {
      console.info('Authenticated');
      const { token, subject } = keycloak
      const url = await getUrlApi('BACKEND_URL');
      const redirectUri = `${protocol}//${host}/concluir-cadastro`
      axios.defaults.baseURL = `${url}/v1/`;
      axios.defaults.headers.common.Authorization = `Bearer ${token}`;

      if (pathname !== '/concluir-cadastro') {
        try {
          const response = await getBySub(subject);
        } catch (e) {
          window.location = redirectUri;
        }
      }

      /*Promise.all([getUserRoles(subject), getUserSelectedRole(subject)])
        .then(([rolesResponse, userRoleResponse]) => {

          roles = rolesResponse;
          role = userRoleResponse;

          configAcessoERoles();
        });*/

      try {
        const response = await getRoles(subject);
        if (response.data) {
          roles = response.data;
        }
      } catch (error) {
        console.log(error);
      }
      let usuarioCadastrado = false;
      try {
        const response = await getSelectedRole(subject);
        if (response.data) {
          role = response.data;
        }
        usuarioCadastrado = true;
      } catch (error) {
        console.log(error);
      }
      try {
        const response = await getBySub(subject);
        if (response.data) {
          roleSelecionada = response.data.atuacaoRoleSelecionada
        }
      } catch (error) {
        console.log(error);
      }

      if(usuarioCadastrado){
        configAcessoERoles(subject);
      }
    }

    ReactDOM.render(
      <BaSeRoot locale="pt-BR" withResetCss={false}>
        <App roles={roles} role={role} keycloak={keycloak} possuiAcesso={possuiAcesso} roleSelecionada={roleSelecionada} selecionarPerfil={selecionarPerfil}/>
        <BaSeDialogContainer />
      </BaSeRoot>
      , document.getElementById('root'),
    );

    keycloak.onTokenExpired = () => {
      console.log('token expired', keycloak.token);
      keycloak.updateToken(30).success(() => {
        console.log('successfully get a new token', keycloak.token);
        axios.defaults.headers.common.Authorization = `Bearer ${keycloak.token}`;
        window.location.reload();
      }).error(() => {
        console.error('Failed to refresh token')
        window.location.reload();
      });
    }
  }).error(() => {
    console.error('Authenticated Failed');
  });
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
